module.exports = __webpack_public_path__ + "img/jts_web_banner_my.51b7b3ac.png";